import type { Service } from './schema'
import { tools } from './tools'

export const servicesPage = {
  eyebrow: 'Services',
  title: 'Automations that do the work your team keeps doing.',
  lede: 'Start with the task that hurts most, stack more as they pay off.',
}

/**
 * The Home Services section: a stack of cards dealt onto a pile as the page scrolls. The display line
 * is the thin + bold pair below.
 */
export const servicesSection = {
  eyebrow: servicesPage.eyebrow,
  titleThin: 'Pick one',
  titleBold: 'or stack a few.',
  explore: 'Explore',
  /** The Work chapter each card opens, by service id (a chapter id from home.ts). */
  work: {
    'service-1': 'case-studies',
    'service-2': 'process',
    'service-3': 'case-studies',
    'service-4': 'experiments',
    'service-5': 'apps',
    'service-6': 'side-projects',
  } as Record<string, string>,
}

export const services: Service[] = [
  {
    id: 'service-1',
    title: 'Workflow Automation',
    summary: 'Smart workflows in n8n, Make.com and Zapier that take over your repetitive daily tasks.',
    outcome: 'Hours back',
    bullets: [
      'Lead capture, follow-up and notifications',
      'Email, report and dashboard automation',
      'Scheduled jobs that run without you',
    ],
    tools: [tools.n8n, tools.make, tools.zapier],
  },
  {
    id: 'service-2',
    title: 'System Integration',
    summary: 'Your apps connected so information flows without copy-paste.',
    outcome: 'One flow',
    bullets: [
      'API connections between your tools',
      'CRM, forms and spreadsheets in sync',
      'Webhooks for real-time updates',
    ],
    tools: [tools.make, tools.gohighlevel, tools.asana],
  },
  {
    id: 'service-3',
    title: 'AI-Powered Solutions',
    summary: 'AI agents that draft, classify and answer inside your process.',
    outcome: 'Smart ops',
    bullets: [
      'AI agents for email and lead triage',
      'Document extraction (OCR) pipelines',
      'RAG chatbots over your own documents',
    ],
    tools: [tools.openai, tools.claude, tools.gemini],
  },
  {
    id: 'service-4',
    title: 'Process Optimization',
    summary: 'I find the steps worth automating — and the ones worth deleting.',
    outcome: 'Lean process',
    bullets: [
      'Workflow audits that find bottlenecks',
      'Reliability fixes and error handling',
      'Performance monitoring and updates',
    ],
    tools: [tools.n8n, tools.zapier, tools.make],
  },
  {
    id: 'service-5',
    title: 'Multi-Platform Support',
    summary: 'Asana, Slack, Airtable, GoHighLevel — your whole stack, unified.',
    outcome: 'Unified stack',
    bullets: [
      'Task, chat and base integrations',
      'GoHighLevel pipelines and workflows',
      'Cross-platform data consistency',
    ],
    tools: [tools.asana, tools.slack, tools.airtable],
  },
  {
    id: 'service-6',
    title: 'Data Management',
    summary: 'Accurate, secure, well-documented data behind every automation.',
    outcome: 'Clean data',
    bullets: [
      'Validation and error handling built in',
      'Organized documentation for every flow',
      'Team training and handover',
    ],
    tools: [tools.gohighlevel, tools.airtable, tools.slack],
  },
]
